import { ChannelStatus, ChannelType, ModelSearchType } from '@/models/channel.model';

export enum ModalViews {
  CREATE = 'create',
  EDIT = 'edit',
  DEACTIVATE = 'deactivate',
  ACTIVATE = 'activate',
}

export enum CreateChannelFormFields {
  NAME = 'name',
  SITE_URL = 'siteUrl',
  COPY_CHANNEL_ID = 'copyChannelId',
  SLUG = 'slug',
  TYPE = 'type',
  MODEL_SEARCH_TYPE = 'modelSearchType',
  // DESCRIPTION = 'description',
}

export enum UpdateChannelFormFields {
  SITE_URL = 'siteUrl',
  STATUS = 'status',
  HIDE_SERIAL_NUMBER = 'hideSerialNumber',
}

export type TCreateChannelFormValues = {
  [CreateChannelFormFields.NAME]: string;
  [CreateChannelFormFields.SITE_URL]: string;
  [CreateChannelFormFields.COPY_CHANNEL_ID]: number;
  [CreateChannelFormFields.SLUG]: string;
  [CreateChannelFormFields.TYPE]: ChannelType;
  // [CreateChannelFormFields.DESCRIPTION]: string;
  [CreateChannelFormFields.MODEL_SEARCH_TYPE]: ModelSearchType;
};

export type TUpdateChannelFormValues = {
  [UpdateChannelFormFields.SITE_URL]: string;
  [UpdateChannelFormFields.STATUS]: ChannelStatus;
  [CreateChannelFormFields.MODEL_SEARCH_TYPE]: ModelSearchType;
};

export const ChannelTypeFilterValues = [
  { label: 'All', value: '' },
  { label: 'Products', value: ChannelType.PRODUCTS },
  { label: 'Parts', value: ChannelType.PARTS },
  { label: 'Showcase', value: ChannelType.SHOWCASE },
];

export const ModelSearchTypeFilterValues = [
  { label: 'Nothing', value: ModelSearchType.NOTHING },
  { label: 'Serial numbers', value: ModelSearchType.SERIAL_NUMBER },
  { label: 'Dates', value: ModelSearchType.DATES },
];
